import Team from './Team';

export default class Department {
    static fromData(data) {
        if (!data) {
            return;
        }

        const department = new Department();

        department.id = data.id || null;
        department.name = data.name;
        department.shortName = data.shortName;
        department.parentDepartmentId = data.parentDepartmentId;
        department.childDepartmentIds = data.childDepartmentIds;
        department.hierarchyPath = data.hierarchyPath;
        department.dateOfFounding = data.dateOfFounding;
        department.dateOfClosure = data.dateOfClosure;
        department.sportsTypeNumber = data.sportsTypeNumber;
        department.hasImage = data.hasImage;
        department.imageUrl = data.imageUrl;
        department.isRoot = department.parentDepartmentId === null;
        department.isViewable = data.isViewable;
        department.isEditable = data.isEditable;
        department.description = data.description;
        department.hasClubFees = data.hasClubFees;
        department.allowOnlineRegistration = data.allowOnlineRegistration;
        department.canEditOnlineRegistration = data.canEditOnlineRegistration;

        department.childDepartments = [];
        if (data.childDepartments) {
            department.childDepartments = data.childDepartments.data.map((departmentData) => Department.fromData(departmentData));
        }

        department.teams = [];
        if (data.teams) {
            department.teams = data.teams.data.map((teamData) => Team.fromData(teamData));
        }

        return department;
    }

    serialize() {
        return Object.assign({}, this);
    }

    extendedName() {
        if (!this.hierarchyPath) {
            return this.name;
        }

        return `${this.hierarchyPath} / ${this.name}`;
    }

    equals(department) {
        return department.id === this.id;
    }

    makeEditable() {
        this.isEditable = true;
        this.childDepartments.forEach((element) => element.makeEditable());
        this.teams.forEach((element) => element.makeEditable());
    }
}
